/**
 * Normalizes Dynamic Form list options so authors can set a display label
 * separately from the Salesforce value (e.g. "Yes" → true).
 * Older CMS content that only stored `option` continues to work.
 */

export interface DynamicFormOptionFields {
    option?: string;
    label?: string;
    value?: string;
}

export interface DynamicFormOptionModel {
    fields: DynamicFormOptionFields;
}

export interface DynamicFormResolvedOption {
    label: string;
    value: string;
}

/** Resolves CMS option rows into label/value pairs (legacy `option` = both). */
export function resolveDynamicFormOptions(
    options: DynamicFormOptionModel[] | null | undefined,
): DynamicFormResolvedOption[] {
    return (options || [])
        .map(item => {
            const legacy = (item.fields?.option || "").trim();
            const label = (item.fields?.label || "").trim() || legacy;
            const value = (item.fields?.value || "").trim() || legacy;
            return { label, value };
        })
        .filter(item => item.label || item.value)
        .map(item => ({
            label: item.label || item.value,
            value: item.value || item.label,
        }));
}

/** ListField row display: prefer label, then value, then legacy option. */
export function getDynamicFormOptionDisplay(item: { fields?: DynamicFormOptionFields }): string {
    const fields = item.fields || {};
    return (fields.label || fields.value || fields.option || "").trim();
}
